import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import { auth, state } from '../../plugin';
import { useLoginFlowPlugin } from '../../providers';
import { CookieService, LocationService, SessionService } from '../../services';

export async function beforeEnterGuard(
  _to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const $loginFlow = useLoginFlowPlugin();

  if (state.isLogin) {
    return next(from.name ? from : { name: $loginFlow.config.baseRoute });
  }

  const code = LocationService.Code;

  if (code) {
    try {
      const token = await auth.exchangeForToken(code);

      CookieService.SetSession(token);

      state.isLogin = true;

      return next({ name: SessionService.FromSession || $loginFlow.config.baseRoute });
    } catch (error) {
      state.onErrorClb(error as Error);
    } finally {
      LocationService.ReplaceHistoryState();
    }
  }

  next();
}
